export default {
      id: "icon-stats-up-usage",
      viewBox: "0 0 10 25",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-stats-up",
      toString: function () {
        return this.url;
      }
    }